import withArchivosAdjuntos from "../../hoc/withTrabajadores/withArchivosAdjuntos";
import ArchivosAdjuntos from "../../view/components/RegistroUsuarios/PerfilProfesional/VistaPerfilProfesional/ArchivosAdjuntos";

export default withArchivosAdjuntos(ArchivosAdjuntos)